import { FC } from "react";

import classes from "./GlobalAppLoading.module.css";
import { getLang, i18n } from "../../i18n";

interface Props {
  text?: string;
}

const GlobalAppLoading: FC<Props> = ({ text }) => {
  const lang = getLang();
  const t = i18n.loading[lang];
  if (!text) text = t.defaultText;
  return (
    <div className={`${classes.loading} ${classes.global}`}>
      <img src="/logo.png" alt="" />
      <div className={classes.status}>{text}</div>
    </div>
  );
};

export default GlobalAppLoading;
